<pmt-action-modal [title]="'assignments.participants.attendances.modalTitle'| transloco"
    [submitButtonText]="'modal.confirmButton'"
    [cancelButtonText]="isReadonly ? 'modal.closeButton' :  'modal.cancelButton'" submitButtonIconCode=""
    (submitted)="save()" class="custom-modal-limiter" [isSaving]="isLoading" [onlyCancel]="isReadonly">
    <ng-container *ngIf="!participantsAttendances">
        <div class="text-center">
            <i class="fa-solid fa-spinner fa-spin"></i>
        </div>
    </ng-container>

    <ng-container *ngIf="participantsAttendances">
        <div class="d-flex flex-column gap-2">
            <div class="alert alert-secondary" *ngIf="isReadonly">
                {{'assignments.participants.attendances.readonlyDescription' | transloco}}
            </div>
            <div class="table-responsive">
                <table class="table">
                    <thead>
                        <tr style="writing-mode: sideways-lr;">
                            <th class="bg-light fixed-column" style="width: 100%;"></th>
                            <th class="bg-light" *ngFor="let date of dates">
                                <div class="d-flex justify-content-center">
                                    <div class="vertical-text text-nowrap text-truncate" style="max-height: 200px;">
                                        <span [ngClass]="{'text-decoration-underline': date.isCurrent}">
                                            {{ date.from | date : "dd.MM.YY" }}
                                        </span>
                                    </div>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngIf="participantsAttendances && participantsAttendances.length">
                            <td class=" text-nowrap bg-light fixed-column"></td>
                            <td *ngFor="let date of dates" class="p-2 bg-light">
                                <div class="btn-group" dropdown [isDisabled]="isSaving || isReadonly">
                                    <button dropdownToggle type="button"
                                        class="btn border-0 dropdown-toggle text-light text-center btn-gradient-green-red">
                                        <i class="fa-solid fa-circle fa-xs"></i>
                                    </button>
                                    <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
                                        <li role="menuitem" role="button">
                                            <a class="dropdown-item cursor-pointer text-success"
                                                (click)="setRestAsAttended(date.eventLessonId)">
                                                <i class="fa-solid fa-circle-check fa-xs"></i>
                                                <span *ngIf="isAnyAttendanceSet(date.eventLessonId)">
                                                    {{'assignments.participants.attendances.restAttended' | transloco }}
                                                </span>

                                                <span *ngIf="!isAnyAttendanceSet(date.eventLessonId)">
                                                    {{'assignments.participants.attendances.allAttended' | transloco }}
                                                </span>
                                            </a>
                                        </li>
                                        <li role="menuitem" role="button">
                                            <a class="dropdown-item cursor-pointer text-danger"
                                                (click)="setRestAsNotAttended(date.eventLessonId)">
                                                <i class="fa-solid fa-circle-xmark fa-xs"></i>

                                                <span *ngIf="isAnyAttendanceSet(date.eventLessonId)">
                                                    {{'assignments.participants.attendances.restNotAttended' |
                                                    transloco}}
                                                </span>

                                                <span *ngIf="!isAnyAttendanceSet(date.eventLessonId)">
                                                    {{'assignments.participants.attendances.allNotAttended' |
                                                    transloco}}
                                                </span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                        <tr *ngIf="participantsAttendances && participantsAttendances.length">
                            <td class=" text-nowrap bg-light fixed-column"></td>
                            <td *ngFor="let date of dates" class="p-2 bg-light">
                                <div class="d-flex flex-column gap-1">
                                    <div class="badge bg-success fs-4">
                                        {{getParticipantsCountByState(date.eventLessonId,
                                        attendanceStateEnum.Attended)}}
                                    </div>
                                    <div class="badge bg-danger fs-4">
                                        {{getParticipantsCountByState(date.eventLessonId,
                                        attendanceStateEnum.Absent)}}
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr *ngFor="let participantsAttendance of participantsAttendances">
                            <td class="bg-light fixed-column align-middle col-fixed-140">
                                <div class="d-flex flex-column w-100 lh-sm"
                                    [tooltip]="personNameService.getFullName(participantsAttendance.personFirstName, participantsAttendance.personLastName)"
                                >
                                    <div class="w-100 overflow-hidden">
                                        <span class="d-block text-nowrap text-truncate">
                                            {{ participantsAttendance.personFirstName }}
                                        </span>
                                    </div>
                                    <div class="w-100 overflow-hidden">
                                        <span class="d-block text-nowrap text-truncate">
                                            {{ participantsAttendance.personLastName }}
                                        </span>
                                    </div>
                                </div>
                            </td>
                            <td *ngFor="let participantsAttendanceDate of participantsAttendance.dates"
                                class="p-2 bg-light">

                                <button class="btn border-0 bg-primary text-light text-center"
                                    [disabled]="!participantsAttendanceDate.isChangeAllowed || isSaving || isReadonly"
                                    *ngIf="isAttendanceDateUndefined(participantsAttendanceDate)"
                                    (click)="changeToNextState($event, participantsAttendanceDate)">
                                    <i class="fa-solid fa-circle fa-xs"></i>
                                </button>

                                <button class="btn border-0 bg-success text-light text-center"
                                    [disabled]="!participantsAttendanceDate.isChangeAllowed || isSaving || isReadonly"
                                    *ngIf="isAttendanceDateAttended(participantsAttendanceDate)"
                                    (click)="changeToNextState($event, participantsAttendanceDate)">
                                    <i class="fa-solid fa-circle-check fa-xs"></i>
                                </button>

                                <button class="btn border-0 bg-danger text-light text-center"
                                    [disabled]="!participantsAttendanceDate.isChangeAllowed || isSaving || isReadonly"
                                    *ngIf="isAttendanceDateAbsent(participantsAttendanceDate)"
                                    (click)="changeToNextState($event, participantsAttendanceDate)">
                                    <i class="fa-solid fa-circle-xmark fa-xs"></i>
                                </button>

                            </td>
                        </tr>
                    </tbody>

                </table>
            </div>
        </div>
    </ng-container>
</pmt-action-modal>